<template>
  <div class="w-container">
    <div>
      <div class="top-title">
        <span v-if="!isCompare">功率-{{ selectModel.turbineType }}</span>
        <span v-else>功率曲线对比</span>
      </div>
      <div v-if="!isCompare">
        <div v-if="menuRightType === 5" class="power-curve">
          <div class="power-curve-item" style="text-align: left">
            <span style="vertical-align: top;color: #fff">湍流：</span>
            <el-select
              v-model="turbulentValue"
              :placeholder="turbulentValue.length > 0 ? '' : '请选择湍流'"
              size="mini"
              multiple
              :multiple-limit="8"
              filterable
              allow-create
              default-first-option
              v-show="!turbulentDisabled"
              v-defaultSelect="[
                turbulentValue,
                turbulentOptions,
                'value',
                'disabled',
                true
              ]"
            >
              <el-option
                v-for="item in turbulentOptions"
                :key="item.value"
                :disabled="item.disabled"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="turbulentValue1"
              :placeholder="turbulentValue.length > 0 ? '' : '请选择湍流'"
              size="mini"
              filterable
              default-first-option
              v-show="turbulentDisabled"
              @change="changeTurbulentValue"
            >
              <el-option
                v-for="item in turbulentOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="power-curve-item" style="text-align: left">
            <span style="vertical-align: top;color: #fff"
              >空气密度（kg/m&sup3;）：</span
            >
            <el-select
              v-model="wspdValue"
              :placeholder="wspdValue.length > 0 ? '' : '请选择空气密度'"
              size="mini"
              multiple
              :multiple-limit="8"
              filterable
              allow-create
              default-first-option
              :disabled="wspdDisabled"
              @change="changeWspdValue"
              v-show="!wspdDisabled"
              v-defaultSelect="[
                wspdValue,
                wspdOptions,
                'value',
                'disabled',
                true
              ]"
            >
              <el-option
                v-for="item in wspdOptions"
                :disabled="item.disabled"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              v-model="wspdValue1"
              :placeholder="wspdValue.length > 0 ? '' : '请选择空气密度'"
              size="mini"
              filterable
              default-first-option
              @change="changeWspdValue1"
              v-show="wspdDisabled"
            >
              <el-option
                v-for="item in wspdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div
            class="power-curve-item"
            v-if="wspdValue.length > 1 || turbulentValue.length > 1"
          >
            <span style="color: #fff">图表：</span>
            <el-select v-model="subtypeValue" placeholder="请选择图表类型">
              <el-option
                v-for="item in subtypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <!--无数据-->
        <div v-if="showEmpty" class="empty">
          <span>暂无数据</span>
        </div>
        <!--曲线内容-->
        <div v-else>
          <!-- 功率-推力系数-cp曲线 -->
          <div v-if="menuRightType === 5">
            <div
              class="power-curve-content"
              v-if="wspdValue.length === 1 && turbulentValue.length === 1"
            >
              <div
                v-loading="tableLoading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                class="res-chart"
              >
                <echart
                  :option="powercurveOptions"
                  :notMerge="true"
                  :divStyle="{ height: '400px', width: '99%' }"
                ></echart>
              </div>
              <el-table
                :data="powerCurveTableData"
                v-loading="tableLoading"
                border
                max-height="400px"
                size="mini"
                key="12"
                style="margin: auto;margin-bottom: 50px;width: 90%;"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column
                  label="风速（m/s）"
                  prop="wspd"
                ></el-table-column>
                <el-table-column
                  label="功率（kW）"
                  prop="power"
                ></el-table-column>
                <el-table-column
                  label="推力系数"
                  prop="thrust"
                ></el-table-column>
                <el-table-column label="Cp" prop="value"></el-table-column>
              </el-table>
            </div>
            <div v-else class="power-curve-content" :style="powerCurveStyle">
              <div
                v-loading="tableLoading"
                element-loading-text="加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                class="res-chart"
              >
                <!-- <div
                  class="e-container"
                  ref="powercurvescp"
                  v-if="
                    powerCurveMoreTableData.length > 0 &&
                      powerCurveMoreTableData[0].ratio
                  "
                ></div>-->
                <div
                  v-if="
                    powerCurveMoreTableData.length > 0 &&
                      powerCurveMoreTableData[0].ratio
                  "
                >
                  <echart
                    :option="powercurvescpOptions"
                    :notMerge="true"
                    :divStyle="{ height: '400px', width: '99%' }"
                  ></echart>
                </div>
                <div v-else>
                  <echart
                    :option="powercurvesOptions"
                    :notMerge="true"
                    :divStyle="{ height: '400px', width: '99%' }"
                  ></echart>
                </div>
                <!--                <div class="e-container" ref="powercurves" ></div>-->
              </div>
              <el-table
                :data="powerCurveMoreTableData"
                border
                max-height="400px"
                size="mini"
                key="13"
                v-loading="tableLoading"
                style="margin: 0 auto 50px;width: 90%;"
                :header-cell-style="{ 'text-align': 'center' }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <template
                  v-if="
                    powerCurveMoreTableData.length > 0 &&
                      powerCurveMoreTableData[0].ratio
                  "
                >
                  <el-table-column
                    label="叶片安装β角(°)"
                    prop="angle"
                  ></el-table-column>
                  <el-table-column
                    label="叶尖速比（λ）"
                    prop="ratio"
                  ></el-table-column>
                  <el-table-column label="cp值" prop="value"></el-table-column>
                </template>
                <template v-else>
                  <el-table-column
                    label="风速(m/s)"
                    prop="wspd"
                  ></el-table-column>
                  <el-table-column
                    v-for="(item, index) in columnsHeader"
                    :label="item.label"
                    :key="index"
                    :prop="item.prop"
                  ></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
          <!--cp曲线-->
          <div v-if="menuRightType === 6">
            <table-cp></table-cp>
          </div>
          <!--功率曲线转换-->
          <div v-if="menuRightType === 7">
            <curve-change></curve-change>
          </div>
        </div>
      </div>
      <!--功率曲线对比-->
      <div v-else>
        <div class="top" v-if="menuRightType !== 10">
          <div class="compare-top">
            <div
              v-for="(item, index) in selectList"
              :key="index"
              class="header-select"
            >
              <div>
                <span>机型：{{ item.label }}</span>
              </div>
              <div v-if="menuRightType === 8">
                <span>湍流：</span>
                <el-select
                  v-model="editData['powervalue' + item.id]"
                  placeholder="请选择湍流"
                  size="mini"
                >
                  <el-option
                    v-for="item in compareTurbulentOptions[item.id]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div v-if="menuRightType === 8 || menuRightType === 9">
                <span>空气密度（kg/m&sup3;）：</span>
                <el-select
                  v-model="editData['wspdvalue' + item.id]"
                  placeholder="请选择空气密度"
                  size="mini"
                >
                  <el-option
                    v-for="item in compareWspdOptions[item.id]"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <el-button
                  v-if="menuRightType !== 10 && index === selectList.length - 1"
                  size="mini"
                  type="primary"
                  @click="confirmClick"
                  >确认</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <!--无数据-->
        <div v-if="showCompareEmpty" class="empty">
          <span>暂无数据</span>
        </div>
        <!--功率对比-->
        <div v-else class="power-curve-compare">
          <div>
            <div
              v-loading="tableLoading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              class="res-chart"
            >
              <echart
                :option="powercurvecompareOptions"
                :notMerge="true"
                :divStyle="{ height: '400px', width: '99%' }"
              ></echart>
              <!--              <div class="e-container" ref="powercurvecompare"></div>-->
            </div>
            <el-table
              :data="powerCurveCompareTableData"
              v-loading="tableCompareLoading"
              border
              size="mini"
              max-height="400px"
              style="margin: auto; margin-bottom: 50px;width: 90%"
            >
              <el-table-column
                label="叶尖速比（λ）"
                prop="ratio"
                v-if="menuRightType === 10"
              ></el-table-column>
              <el-table-column
                label="风速（m/s）"
                prop="wspd"
                v-else
              ></el-table-column>
              <el-table-column
                v-for="(item, index) in columns"
                :label="item.label"
                :prop="item.prop"
                :key="index"
              ></el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  filterCurveMoreTableData,
  filterPowerCurveData,
  filterPowerCurveMoreData
} from '../helper/filter';
import TableCp from './components/table-cp';
import CurveChange from './components/curve-change';
import isEmpty from 'lodash/isEmpty';

export default {
  props: {},
  components: {
    TableCp,
    CurveChange
  },
  data() {
    return {
      righttype: null,
      topTitle: '',
      powerCurveStyle: '70px',
      // 湍流选择多选
      turbulentValue: [],
      // 湍流选择单选
      turbulentValue1: '',
      turbulentOptions: [],
      // 空气密度多选
      wspdValue: [],
      // 空气密度单选
      wspdValue1: '',
      wspdOptions: [],
      // 图表类型
      subtypeValue: '1',
      subtypeOptions: [
        {
          value: '1',
          label: '功率（KW）'
        },
        {
          value: '2',
          label: '推力系数'
        },
        {
          value: '3',
          label: 'cp'
        }
      ],
      // 功率曲线页面
      powerCurveTableData: [],
      powerCurvedata: {},
      // 多对1
      // 多条功率曲线
      powerCurveMoreTableData: [],
      powerCurvedataMore: {},
      // 多条功率曲线原始值
      powerCurveMore: [],
      // 选择是否禁止
      turbulentDisabled: false,
      wspdDisabled: false,
      // 表格loading状态
      tableLoading: false,
      // 选择的机型id
      idList: [],
      // 对比功率曲线湍流选择
      turbulentValueCompare: 0.1,
      // 对比功率曲线空气密度选择
      wspdValueCompare: 1.225,
      // 动态select绑定的数据
      editData: {},
      // 对比曲线数据
      powerCurvedataCompare: {},
      // 对比功率表格数据
      powerCurveCompareTableData: [],
      // 对比表格的loading
      tableCompareLoading: false,
      showEmpty: false,
      showCompareEmpty: false,
      // 选择的机型的数据
      selectModel: {},
      paddingValue: {
        paddingTop: '70px'
      },
      // 功率曲线对比的集合
      compareWspdOptions: {},
      compareTurbulentOptions: {},
      // echart图表配置变量
      powercurveOptions: null,
      powercurvescpOptions: {},
      powercurvesOptions: null,
      // 对比曲线的配置
      powercurvecompareOptions: null,
      // 刷新页面重复发起请求问题
      // 单选多选页面请求问题
      isChangeWspdValue: false,
      isChangeTurbulentValue: false,
      // 对比功率曲线的初始值问题
      compareWspdFirst: [],
      compareTurbulentFirst: []
    };
  },
  directives: {
    defaultSelect: function(el, bindings) {
      //values v-model绑定值
      //options下拉选项
      //prop对应options中的value属性
      //defaultProp默认值判断属性
      //defaultValue默认值判断值

      const [values, options, prop] = bindings.value;
      //需要隐藏的标签索引
      let indexs = [];

      const tempData = values.map(a => options.find(op => op[prop] === a));

      if (tempData.length === 1) {
        indexs.push(0);
      } else {
        indexs = [];
      }

      const dealStyle = function(tags) {
        tags.forEach((el, index) => {
          if (
            indexs.includes(index) &&
            ![...el.classList].includes('select-tag-close-none')
          ) {
            el.classList.add('closeTag');
          } else {
            el.classList.remove('closeTag');
          }
        });
      };
      //设置样式隐藏close icon

      const tags = el.querySelectorAll('.el-tag__close');

      if (tags.length === 0) {
        //初始化tags为空处理

        setTimeout(() => {
          const tagTemp = el.querySelectorAll('.el-tag__close');

          dealStyle(tagTemp);
        });
      } else {
        dealStyle(tags);
      }
    }
  },
  computed: {
    ...mapState('model', [
      'checkedList',
      'menuRightType',
      'isCompare',
      'modelList',
      'currentModel'
    ]),
    selectList() {
      if (isEmpty(this.modelList)) return [];
      const selects = [];
      this.modelList.forEach((item, i) => {
        // this.$set(
        //   this.editData,
        //   'powervalue' + item.id,
        //   this.compareTurbulentFirst[i]
        // );
        // this.$set(
        //   this.editData,
        //   'wspdvalue' + item.id,
        //   this.compareWspdFirst[i]
        // );

        // this.$set(
        //   this.editData,
        //   'powervalue' + item.id,
        //   this.compareTurbulentOptions[item.id][0].value
        // );
        //
        // this.$set(
        //   this.editData,
        //   'wspdvalue' + item.id,
        //   this.compareWspdOptions[item.id][0].value
        // );

        selects.push({
          label: item.name,
          value: `powervalue${i === 0 ? '' : i}`,
          wspdValue: `wspdvalue${i === 0 ? '' : i}`,
          id: item.id
        });
      });
      return selects;
    },
    // 多条功率曲线的table-header
    columnsHeader() {
      if (isEmpty(this.powerCurveMore)) return [];
      const cols = [];
      this.powerCurveMore.forEach((eco, i) => {
        if (eco.ratio) {
          return;
        }
        let str;
        if (this.turbulentValue.length > 1) {
          // 湍流百分比
          // let turbulencePercentage = eco[0].turbulence;
          // if (turbulencePercentage || turbulencePercentage === 0) {
          //   str = `湍流${turbulencePercentage}功率`;
          // }
          let turbulenceStr = `功率（TI=${eco[0].turbulenceNum}，${eco[0].turbulenceStr}）`;
          str = turbulenceStr;
          if (this.subtypeValue === '2') {
            str = `推力系数${i === 0 ? '' : i}`;
          }
        }
        if (this.wspdValue.length > 1) {
          str = `空气密度${eco[0].density}功率`;
          if (this.subtypeValue === '2') {
            str = `空气密度${eco[0].density}推力系数`;
          }
        }
        cols.push({
          label: str,
          prop: `power${i === 0 ? '' : i}`
        });
      });
      return cols;
    },
    // 对比功率曲线的列数据
    columns() {
      if (isEmpty(this.modelList)) return [];
      const cols = [];
      this.modelList.forEach((eco, i) => {
        if (this.menuRightType === 10) {
          cols.push({
            label: eco.name + '(cp值)',
            prop: `power${i === 0 ? '' : i}`
          });
          return;
        }
        cols.push({
          label: eco.name,
          prop: `power${i === 0 ? '' : i}`
        });
      });
      return cols;
    }
  },
  watch: {
    editData: {
      handler(val) {
        console.log(val);
      },
      deep: true
    },
    menuRightType(val, oldVal) {
      this.$nextTick(() => {
        this.showEmpty = false;
        this.showCompareEmpty = false;
      });
      if (val === 8) {
        this.righttype = 1;
      }
      if (val === 9) {
        this.righttype = 2;
      }
      if (val === 10) {
        this.righttype = 3;
      }
      if (this.isCompare) {
        if (oldVal === 8 || oldVal === 9 || oldVal === 10) {
          this.fetchComparePowerCurveList();
        }
        // if (val === 8) {
        //   this.modelList.forEach(async (item, index) => {
        //     // this.fetchPowerCurveTurbulenceList(item.id);
        //     // this.fetchPowerCurveDensityList(item.id);
        //     await this.compareFetch(item.id);
        //     if (index === this.modelList.length - 1) {
        //       // this.editData = {};
        //       await this.fetchComparePowerCurveList();
        //     }
        //   });
        // } else if (val === 9) {
        //   this.fetchComparePowerCurveList();
        // } else if (val === 10) {
        //   this.fetchComparePowerCurveList();
        // }
      } else {
        if (val === 5) {
          this.wspdValue = [];
          this.turbulentValue = [];
          // if (this.wspdValue.length > 1 || this.turbulentValue.length > 1) {
          //   this.wspdValue = [];
          //   this.turbulentValue = [];
          // }
          if (Object.keys(this.currentModel).length !== 0) {
            this.fetch();
          }
        }
      }
    },
    // 当前选中的机型
    currentModel(val) {
      this.$nextTick(() => {
        this.showEmpty = false;
      });
      this.wspdValue = [];
      this.turbulentValue = [];
      if (typeof val === 'object' && Object.keys(val).length <= 0) {
        this.showEmpty = true;
        return;
      }
      this.selectModel = val;
      if (this.menuRightType === 5) {
        this.idList = [val.turbineTypeId];
        if (!this.isCompare) {
          if (this.wspdValue.length > 1 || this.turbulentValue.length > 1) {
            this.fetchPowerCurveMore();
          } else {
            this.wspdValue = [];
            this.turbulentValue = [];
            this.fetch();
          }
        }
      }
    },
    modelList(val) {
      if (val.length <= 1) {
        return;
      }
      this.paddingValue.paddingTop = `${val.length * 50}px`;
      // if (val.length === this.checkedList.length && this.isCompare) {
      //   this.$nextTick(() => {
      //     this.fetchComparePowerCurveList();
      //   });
      // }
      // val.forEach(item => {
      //   this.$set(
      //     this.editData,
      //     'powervalue' + item.id,
      //     this.compareTurbulentOptions[item.id][0].value
      //   );
      //   this.$set(
      //     this.editData,
      //     'wspdvalue' + item.id,
      //     this.compareWspdFirst[item.id][0].value
      //   );
      // });
    },
    turbulentValue(val) {
      // 把空气密度已经修改的值赋值为false，就不会多发请求
      this.isChangeWspdValue = false;
      if (val.length < 1) {
        this.showEmpty = true;
        return;
      }
      this.wspdDisabled = val.length > 1 ? true : false;
      // 湍流长度大于1，空气密度多选框为空时，改变湍流应该发生请求
      if (val.length > 1 && this.wspdValue1) {
        this.fetchPowerCurveMore();
      }
      if (val.length > 1 && this.wspdValue.length > 0) {
        this.wspdValue1 = this.wspdValue[0];
        this.fetchPowerCurveMore();
      }
      if (val.length > 4) {
        this.powerCurveStyle = {
          paddingTop: '90px'
        };
      }
      this.powerCurveMore = [];
      if (val.length === 1 && this.wspdValue.length > 0) {
        this.wspdOptions = null;
        this.fetchPowerCurveDensityList();
        this.powerCurveStyle = {
          paddingTop: '70px'
        };
      }
    },
    wspdValue(val) {
      if (val.length < 1) {
        this.showEmpty = true;
        return;
      }
      this.turbulentDisabled = val.length > 1 ? true : false;
      if (val.length > 1 && this.turbulentValue.length > 0) {
        this.turbulentValue1 = this.turbulentValue[0];
        this.fetchPowerCurveMore();
      }
      if (val.length > 4) {
        this.powerCurveStyle = {
          paddingTop: '90px'
        };
      }
      this.powerCurveMore = [];
      if (val.length === 1 && this.turbulentValue.length > 0) {
        this.powerCurveStyle = {
          paddingTop: '70px'
        };
        if (this.isChangeWspdValue) {
          this.fetchPowerCurve();
        }
      }
      // 湍流为空时湍流单选框值也为空
      if (val.length > 1 && this.turbulentValue.length === 0) {
        this.turbulentValue1 = [];
      }
    },
    subtypeValue() {
      if (this.turbulentValue.length > 0 && this.wspdValue.length > 0) {
        this.fetchPowerCurveMore();
      }
      // 湍流长度大于1时，空气密度多选为空，单选有值需要发起请求
      if (this.turbulentValue.length > 1 && this.wspdValue1) {
        this.fetchPowerCurveMore();
      }
    },
    checkedList(val, oldVal) {
      if (val.length === 0) {
        return;
      }
      this.idList = val;
      if (this.isCompare) {
        // this.editData = {};
        if (oldVal.length > val.length) {
          // let deletedId;
          oldVal.forEach(item => {
            if (!val.includes(item)) {
              // deletedId = item;
              delete this.editData['wspdvalue' + item];
              delete this.editData['powervalue' + item];
              this.compareWspdFirst.pop();
            }
          });
          // this.$nextTick(() => {
          //   this.fetchComparePowerCurveList();
          // });
        } else {
          this.fetchPowerCurveTurbulenceList(val[val.length - 1]);
        }
      }
    },
    isCompare(val) {
      if (!val) {
        this.editData = {};
        this.compareWspdOptions = {};
        this.compareTurbulentOptions = {};
      } else {
        this.compareWspdFirst = [];
        this.compareTurbulentFirst = [];
        this.modelList.forEach(item => {
          this.fetchPowerCurveTurbulenceList(item.id);
          // this.fetchPowerCurveDensityList(item.id);
          // this.compareFetch(item.id);
          // if (index === this.compareWspdFirst.length - 1) {
          //   // this.editData = {};
          //   this.fetchComparePowerCurveList();
          // }
        });
      }
    },
    compareWspdFirst(val) {
      if (val.length === this.checkedList.length) {
        this.$nextTick(() => {
          this.fetchComparePowerCurveList();
        });
      }
    }
  },
  methods: {
    // 单选改变湍流
    changeTurbulentValue() {
      this.fetchPowerCurveMore();
    },
    // 多选改变湍流
    changeTurbulentValue1() {
      this.isChangeTurbulentValue = true;
    },
    // 多选改变空气密度
    changeWspdValue() {
      this.isChangeWspdValue = true;
    },
    // 单选改变空气密度
    changeWspdValue1() {
      this.fetchPowerCurveMore();
    },
    async compareFetch(idValue) {
      // if (this.tableCompareLoading) {
      //   return;
      // }
      // this.tableCompareLoading = true;
      this.fetchPowerCurveTurbulenceList(idValue);
      // this.fetchPowerCurveDensityList(idValue);
      // try {
      //   await this.fetchPowerCurveTurbulenceList(idValue);
      //   await this.fetchPowerCurveDensityList(idValue);
      //   // this.tableCompareLoading = false;
      // } catch (e) {
      //   // this.tableCompareLoading = false;
      //   throw e;
      // }
    },
    async fetch() {
      if (this.tableLoading) {
        return;
      }
      this.tableLoading = true;
      try {
        await this.fetchPowerCurveTurbulenceList();
        await this.fetchPowerCurveDensityList();
        // await this.fetchPowerCurve();
        // await Promise.all([
        //   this.fetchPowerCurveDensityList(),
        //   this.fetchPowerCurveTurbulenceList(),
        //   this.fetchPowerCurve()
        // ]);
      } catch (e) {
        this.tableLoading = false;
        throw e;
      }
      this.tableLoading = false;
    },
    // 获取功率-推力系数-cp曲线
    async fetchPowerCurve() {
      this.showEmpty = false;
      await this.$fetch('/windfarm/turbineType/getCurveData', {
        params: {
          density: this.wspdValue[0],
          turbulence: this.turbulentValue[0],
          turbineTypeId: this.currentModel.turbineTypeId
        }
      }).then(res => {
        if (res.code === 0) {
          if (!res.data.curveDataList) {
            this.showEmpty = true;
            return;
          }
          // 去除相同风速的同样的数据
          let obj = {};
          let data = res.data.curveDataList.reduce(function(
            prevArr,
            currentItem
          ) {
            obj[currentItem.wspd]
              ? ''
              : (obj[currentItem.wspd] = true && prevArr.push(currentItem));
            return prevArr;
          },
          []);
          this.powerCurveTableData = data;
          this.powerCurvedata = filterPowerCurveData(data);
          this.$nextTick(() => {
            this.powerCurveInit(this.powerCurvedata);
          });
        }
      });
    },
    powerCurveInit(obj) {
      this.powercurveOptions = {
        xAxis: {
          name: '风速（m/s）',
          type: 'value',
          splitNumber: 5,
          min: 0,
          max: 25,
          // nameGap: 75,
          nameLocation: 'center',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff' //左边线的颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff' //坐标值得具体的颜色
            }
          },
          onZero: false
        },
        tooltip: {
          trigger: 'axis'
          // formatter: function(params) {
          //   let res = '<span>' + params[0].axisValue + '（m/s）</span>';
          //   for (var i = 0; i < params.length; i++) {
          //     res +=
          //       '<p>' +
          //       params[i].seriesName +
          //       ':' +
          //       params[i].value[1] +
          //       '</p>';
          //   }
          //   return res;
          // }
        },
        backgroundColor: '#3b3a39',
        toolbox: {
          feature: {}
        },
        legend: {
          data: ['功率', '推力系数', 'Cp'],
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '4%',
          right: '10%',
          bottom: '10%',
          containLabel: true
        },
        yAxis: [
          {
            position: 'left',
            type: 'value',
            name: '功率（kW）',
            min: 0,
            max: value => {
              if (value.max <= 10) {
                return 12;
              }

              let max = value.max * 1.2;
              let val = max / 5;
              const round = true;
              const exponent = Math.floor(Math.log(val) / Math.LN10);
              const exp10 = Math.pow(10, exponent);
              const f = val / exp10; // 1 <= f < 10
              let nf;
              if (round) {
                if (f < 1.5) {
                  nf = 1;
                } else if (f < 2.5) {
                  nf = 2;
                } else if (f < 4) {
                  nf = 3;
                } else if (f < 7) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              } else {
                if (f < 1) {
                  nf = 1;
                } else if (f < 2) {
                  nf = 2;
                } else if (f < 3) {
                  nf = 3;
                } else if (f < 5) {
                  nf = 5;
                } else {
                  nf = 10;
                }
              }
              val = nf * exp10;
              return val * 5 <= value.max ? val * 6 : val * 5;
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          {
            position: 'right',
            offset: 20,
            type: 'value',
            name: '推力系数',
            // axisTick: {
            //   show: false
            // },
            // y轴样式
            axisLine: {
              lineStyle: {
                color: '#fff'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          {
            position: 'right',
            offset: 60,
            type: 'value',
            name: 'Cp',
            // axisTick: {
            //   show: false
            // },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            splitLine: {
              show: false,
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        series: [
          {
            name: '功率',
            type: 'line',
            data: obj.power,
            yAxisIndex: '0'
          },
          {
            name: '推力系数',
            type: 'line',
            data: obj.thrust,
            yAxisIndex: '1'
          },
          {
            name: 'Cp',
            type: 'line',
            data: obj.value,
            yAxisIndex: '2'
          }
        ]
      };
    },
    // 获取多条功率cp曲线
    async fetchPowerCurveMore() {
      if (this.isCompare) {
        return;
      }
      this.tableLoading = true;
      this.showEmpty = false;
      this.powerCurveMoreTableData = [];
      this.powerCurvedataMore = {};
      await this.$fetch('/windfarm/turbineType/getCurveDataList', {
        params: {
          densitys:
            this.wspdValue.length > 1
              ? this.wspdValue.join(',')
              : this.wspdValue1,
          turbulences:
            this.turbulentValue.length > 1
              ? this.turbulentValue.join(',')
              : this.turbulentValue1,
          turbineTypeId: this.currentModel.turbineTypeId,
          type: this.subtypeValue
        },
        showError: true
      })
        .then(res => {
          if (res.code === 0) {
            if (!res.data.curveDataList) {
              this.showEmpty = true;
              this.tableLoading = false;
              return;
            }
            if (res.data.curveDataList[0].ratio) {
              this.$nextTick(() => {
                this.powerCurveMoreTableData = res.data.curveDataList.map(
                  item => {
                    let obj = {
                      angle: item.angle,
                      value: item.value,
                      ratio: item.ratio
                    };
                    return obj;
                  }
                );
              });
            } else {
              if (this.subtypeValue === '2') {
                this.$nextTick(() => {
                  this.powerCurveMoreTableData = filterCurveMoreTableData(
                    res.data.curveDataList,
                    0,
                    this.subtypeValue
                  );
                });
              } else {
                this.$nextTick(() => {
                  this.powerCurveMoreTableData = filterCurveMoreTableData(
                    res.data.curveDataList,
                    this.menuRightType
                  );
                });
              }
            }
            if (!res.data.curveDataList[0].ratio) {
              this.powerCurvedataMore = filterPowerCurveMoreData(
                res.data.curveDataList,
                this.menuRightType,
                this.subtypeValue
              );
            } else {
              this.powerCurvedataMore = res.data.curveDataList;
            }
            this.powerCurveMore = res.data.curveDataList;
            this.$nextTick(() => {
              this.powerCurveMoreInit(this.powerCurvedataMore);
            });
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(e => {
          this.tableLoading = false;
          throw e;
        });
    },
    powerCurveMoreInit(obj) {
      if (obj && obj[0].ratio) {
        let dataObj = { dimensions: null, cpCureData: null };
        let dimensions = ['ratio'];
        dimensions.push(obj[0].angle);
        let type = [{ type: 'line' }];
        dataObj.dimensions = dimensions;
        dataObj.cpCureData = obj.map(item => {
          return [item.ratio, item.value];
        });
        dataObj.type = type;
        let data = dataObj;
        // const eIns = echarts.init(this.$refs.powercurvescp, 'light');
        if (!data) {
          return;
        }
        this.powercurvescpOptions = {
          dataset: {
            // 提供一份数据。
            dimensions: data.dimensions,
            source: data.cpCureData
          },
          xAxis: {
            name: '叶尖速比（λ）',
            type: 'category',
            boundaryGap: false,
            axisLine: {
              interval: 'auto',
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            splitLine: {
              interval: 'auto',
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          tooltip: {
            trigger: 'axis',
            formatter: function(params) {
              let res = '<span>' + params[0]['name'] + '</span>';
              for (var i = 0; i < params.length; i++) {
                res +=
                  '<p>' +
                  params[i].seriesName +
                  '°:' +
                  params[i].value[1] +
                  '</p>';
              }
              return res;
            }
          },
          backgroundColor: '#3b3a39',
          legend: {
            textStyle: {
              color: '#fff'
            },
            top: '6%',
            padding: 5,
            formatter: function(name) {
              return name + '°';
            }
          },
          grid: {
            left: '5%',
            right: '10%',
            bottom: '5%',
            containLabel: true
          },
          yAxis: {
            name: 'cp值',
            max: function(val) {
              return Math.ceil(val.max * 1.2);
            },
            axisLine: {
              lineStyle: {
                type: 'solid',
                color: '#fff'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            }
          },
          series: data.type
        };
        return;
      }
      let legends = [];
      this.powerCurveMore.forEach((item, i) => {
        let str;
        if (this.turbulentValue.length > 1) {
          // 湍流百分比
          // let turbulencePercentage = item[0].turbulence;
          // if (turbulencePercentage || item[0].turbulence === 0) {
          //   str = `湍流${turbulencePercentage}功率`;
          // }
          let turbulenceStr = `功率（TI=${item[0].turbulenceNum}，${item[0].turbulenceStr}）`;
          str = turbulenceStr;
          if (this.subtypeValue === '2') {
            str = `推力系数${i === 0 ? '' : i}`;
          }
        } else if (this.wspdValue.length > 1) {
          str = `空气密度${item[0].density}功率`;
          if (this.subtypeValue === '2') {
            str = `空气密度${item[0].density}推力系数`;
          }
        }
        legends.push(str);
      });
      let serciesData = this.powerCurveMore.map((item, index) => {
        return {
          name: legends[index],
          type: 'line',
          data: obj[index]
        };
      });
      let yxis = [];
      let yxisObj = {
        position: 'left',
        type: 'value',
        name: '',
        min: 0,
        max: value => {
          let max = value.max * 1.2;
          let val = max / 5;
          const round = true;
          const exponent = Math.floor(Math.log(val) / Math.LN10);
          const exp10 = Math.pow(10, exponent);
          const f = val / exp10; // 1 <= f < 10
          let nf;
          if (round) {
            if (f < 1.5) {
              nf = 1;
            } else if (f < 2.5) {
              nf = 2;
            } else if (f < 4) {
              nf = 3;
            } else if (f < 7) {
              nf = 5;
            } else {
              nf = 10;
            }
          } else {
            if (f < 1) {
              nf = 1;
            } else if (f < 2) {
              nf = 2;
            } else if (f < 3) {
              nf = 3;
            } else if (f < 5) {
              nf = 5;
            } else {
              nf = 10;
            }
          }
          val = nf * exp10;
          return val * 5;
        },
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: '#fff'
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        }
      };
      if (this.subtypeValue === '1') {
        yxisObj = {
          name: '功率（kW）',
          min: 0,
          max: value => {
            return value.max * 1.2;
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        };
        yxis.push(yxisObj);
      }
      if (this.subtypeValue === '2') {
        yxisObj.name = '推力系数';
        yxis.push(yxisObj);
      }

      this.powercurvesOptions = {
        xAxis: {
          name: '风速(m/s)',
          type: 'value',
          splitNumber: 5,
          min: 0,
          max: 25,
          axisLine: {
            onZero: false,
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params) {
            let res = '<span>' + params[0]['name'] + '</span>';
            for (var i = 0; i < params.length; i++) {
              res +=
                '<p>' +
                params[i].seriesName +
                ': ' +
                params[i].value[1] +
                '</p>';
            }
            return res;
          }
        },
        backgroundColor: '#3b3a39',
        toolbox: {
          feature: {}
        },
        legend: {
          data: legends,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: yxis,
        series: serciesData
      };
    },
    handleSelectData(dataDeep) {
      let densitys = [];
      let turbulences = [];
      for (let key in dataDeep) {
        if (key.substring(0, 9) === 'wspdvalue') {
          densitys.push(dataDeep[key]);
        }
        if (key.substring(0, 10) === 'powervalue') {
          turbulences.push(dataDeep[key]);
        }
      }
      return { densitys, turbulences };
    },
    // 获取对比功率曲线
    async fetchComparePowerCurveList(val) {
      let dataDeep = JSON.parse(JSON.stringify(this.editData));
      let dataObj = this.handleSelectData(dataDeep);
      if (!val && val !== 1) {
        if (dataObj['densitys'].length === 0) {
          // for (let i = 0; i < this.modelList.length; i++) {
          //   dataObj['densitys'].push(this.compareWspdFirst[this.modelList]);
          //   dataObj['turbulences'].push(this.compareTurbulentFirst[i]);
          // }
          this.modelList.forEach(item => {
            dataObj['densitys'].push(this.compareWspdOptions[item.id][0].value);
            dataObj['turbulences'].push(
              this.compareTurbulentOptions[item.id][0].value
            );
          });
        }
        // else {
        //   dataObj['densitys'].push(
        //     this.compareWspdFirst[this.compareWspdFirst.length - 1]
        //   );
        //   dataObj['turbulences'].push(
        //     this.compareTurbulentFirst[this.compareTurbulentFirst.length - 1]
        //   );
        // }
      }
      // if (this.menuRightType === 9) {
      //   // dataObj.turbulences = [];
      // }
      // if (this.menuRightType === 10) {
      //   // dataObj.turbulences = [];
      //   // dataObj.densitys = [];
      // }
      this.tableCompareLoading = true;
      this.showCompareEmpty = false;
      await this.$fetch('/windfarm/turbineType/getPowerCurves', {
        params: {
          turbineTypeIds: this.checkedList.join(','),
          densitys: dataObj.densitys.join(','),
          turbulences: dataObj.turbulences.join(','),
          type: this.righttype
        },
        showLoading: true,
        showSuccess: true,
        showError: true
      })
        .then(res => {
          if (res.code === 0) {
            if (!res.data.powerCurveList) {
              this.tableCompareLoading = false;
              this.showCompareEmpty = true;
              return;
            }
            this.powerCurveCompareTableData = [];
            this.$nextTick(() => {
              this.powerCurveCompareTableData = filterCurveMoreTableData(
                res.data.powerCurveList,
                this.menuRightType,
                null,
                this.modelList
              );
            });
            this.powerCurvedataCompare = filterPowerCurveMoreData(
              res.data.powerCurveList,
              this.menuRightType
            );
            this.$nextTick(() => {
              this.powerCurveCompareInit(this.powerCurvedataCompare, true);
            });
            this.tableCompareLoading = false;
          } else {
            this.tableCompareLoading = false;
          }
        })
        .catch(e => {
          this.tableCompareLoading = false;
          throw e;
        });
    },
    // 渲染对比曲线
    powerCurveCompareInit(obj) {
      let dataLegends = this.modelList.map(item => {
        return item.name;
      });
      let yxid = [];
      let axid = {
        name: '风速(m/s)',
        type: 'value',
        splitNumber: 5,
        min: 0,
        max: value => {
          if (value.max <= 10) {
            return 10;
          }

          let max = value.max * 1.2;
          let val = max / 5;
          const round = true;
          const exponent = Math.floor(Math.log(val) / Math.LN10);
          const exp10 = Math.pow(10, exponent);
          const f = val / exp10; // 1 <= f < 10
          let nf;
          if (round) {
            if (f < 1.5) {
              nf = 1;
            } else if (f < 2.5) {
              nf = 2;
            } else if (f < 4) {
              nf = 3;
            } else if (f < 7) {
              nf = 5;
            } else {
              nf = 10;
            }
          } else {
            if (f < 1) {
              nf = 1;
            } else if (f < 2) {
              nf = 2;
            } else if (f < 3) {
              nf = 3;
            } else if (f < 5) {
              nf = 5;
            } else {
              nf = 10;
            }
          }
          val = nf * exp10;
          return val * 5;
        },
        axisLine: {
          lineStyle: {
            type: 'solid',
            color: '#fff'
          },
          onZero: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            type: 'dashed'
          }
        }
      };
      if (this.menuRightType === 9) {
        yxid.push({
          position: 'left',
          type: 'value',
          name: '推力系数',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        });
      }
      if (this.menuRightType === 8) {
        yxid.push({
          position: 'left',
          type: 'value',
          name: '功率（kW）',
          min: 0,
          max: value => {
            if (value.max <= 10) {
              return 10;
            }

            let max = value.max * 1.2;
            let val = max / 5;
            const round = true;
            const exponent = Math.floor(Math.log(val) / Math.LN10);
            const exp10 = Math.pow(10, exponent);
            const f = val / exp10; // 1 <= f < 10
            let nf;
            if (round) {
              if (f < 1.5) {
                nf = 1;
              } else if (f < 2.5) {
                nf = 2;
              } else if (f < 4) {
                nf = 3;
              } else if (f < 7) {
                nf = 5;
              } else {
                nf = 10;
              }
            } else {
              if (f < 1) {
                nf = 1;
              } else if (f < 2) {
                nf = 2;
              } else if (f < 3) {
                nf = 3;
              } else if (f < 5) {
                nf = 5;
              } else {
                nf = 10;
              }
            }
            val = nf * exp10;
            return val * 5;
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        });
      }
      if (this.menuRightType === 10) {
        yxid.push({
          position: 'left',
          type: 'value',
          name: 'cp值',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        });
        axid = {
          name: '叶尖速比（λ）',
          type: 'category',
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#fff'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed'
            }
          }
        };
      }
      let dataSeries = this.modelList.map((item, i) => {
        return {
          name: item.name,
          type: 'line',
          data: obj[i]
        };
      });

      this.powercurvecompareOptions = {
        xAxis: axid,
        tooltip: {
          trigger: 'axis'
        },
        backgroundColor: '#3b3a39',
        toolbox: {
          feature: {}
        },
        legend: {
          data: dataLegends,
          textStyle: {
            color: '#fff'
          }
        },
        grid: {
          left: '3%',
          right: '6%',
          bottom: '3%',
          containLabel: true
        },
        yAxis: yxid,
        series: dataSeries
      };

      // eIns.setOption(option);
    },
    confirmClick() {
      this.fetchComparePowerCurveList(1);
    },
    // 获取功率曲线空气密度集合
    async fetchPowerCurveDensityList(id, val) {
      this.wspdValue = [];
      this.wspdValue1 = '';
      let turbulence;
      if (this.isCompare) {
        // this.modelList.forEach((item, index) => {
        //   if (item.id === id) {
        //     // if (
        //     //   this.compareTurbulentOptions[index] &&
        //     //   this.compareTurbulentOptions[index][0]
        //     // ) {
        //     //   turbulence = this.compareTurbulentOptions[index][0].value || 0.14;
        //     //   turbulence =
        //     //     this.compareTurbulentOptions[index][0].value === 0
        //     //       ? 0
        //     //       : turbulence;
        //     // } else {
        //     //   turbulence = 0;
        //     // }
        //     let obj = JSON.parse(JSON.stringify(this.compareTurbulentFirst));
        //     turbulence = this.compareTurbulentFirst[index];
        this.modelList.forEach(item => {
          if (item.id === id) {
            turbulence = val;
          }
        });
      } else {
        if (this.turbulentValue.length === 1) {
          turbulence = this.turbulentValue[0];
        } else {
          turbulence = '';
        }
      }
      await this.$fetch('/windfarm/turbineType/getPowerCurveDensityList', {
        params: {
          turbineTypeId: this.isCompare ? id : this.currentModel.turbineTypeId,
          turbulence
        }
      }).then(res => {
        if (res.code === 0) {
          if (!res.data.densityList) {
            return;
          }
          let wspdOptionsArr = [];
          res.data.densityList.map(item => {
            let wspdOptionsObj = {};
            wspdOptionsObj.value = item.density;
            wspdOptionsObj.label = item.density;
            wspdOptionsObj.disabled = false;
            wspdOptionsArr.push(wspdOptionsObj);
          });
          this.wspdOptions = wspdOptionsArr;
          this.wspdValue1 = wspdOptionsArr[0].value;
          this.wspdValue.push(wspdOptionsArr[0].value);
          if (this.isCompare) {
            // this.compareWspdOptions.push(wspdOptionsArr);
            this.compareWspdOptions[id] = wspdOptionsArr;
            this.compareWspdFirst.push(wspdOptionsArr[0].value);
            this.$set(this.editData, 'wspdvalue' + id, wspdOptionsArr[0].value);
          }
          if (this.turbulentValue.length === 1 && this.wspdValue.length > 0) {
            this.fetchPowerCurve();
          }
        }
      });
    },
    // 获取功率曲线湍流集合
    async fetchPowerCurveTurbulenceList(id) {
      await this.$fetch('/windfarm/turbineType/getPowerCurveTurbulenceList', {
        params: {
          turbineTypeId: this.isCompare ? id : this.currentModel.turbineTypeId
        }
      }).then(res => {
        if (res.code === 0) {
          if (!res.data.turbulenceList) {
            return;
          }
          let turbulenceListArr = [];
          res.data.turbulenceList.map(item => {
            let turbulenceListObj = {};
            turbulenceListObj.value = item.turbulence;
            turbulenceListObj.label = item.turbulence;
            turbulenceListObj.disabled = false;
            // turbulenceListObj.disabled = false;
            turbulenceListArr.push(turbulenceListObj);
          });
          this.turbulentOptions = turbulenceListArr;
          this.turbulentValue1 = turbulenceListArr[0].value;
          this.turbulentValue.push(turbulenceListArr[0].value);
          if (this.isCompare) {
            // this.compareTurbulentOptions.push(turbulenceListArr);
            this.compareTurbulentOptions[id] = turbulenceListArr;
            this.compareTurbulentFirst.push(turbulenceListArr[0].value);
            this.fetchPowerCurveDensityList(id, turbulenceListArr[0].value);
            this.$set(
              this.editData,
              'powervalue' + id,
              turbulenceListArr[0].value
            );
          }
        }
      });
    }
  },
  mounted() {
    if (Object.keys(this.currentModel).length !== 0) {
      this.selectModel = this.currentModel;
      this.idList = [this.currentModel.turbineTypeId];
      this.fetch();
    }
  }
};
</script>

<style lang="less" scoped>
.w-container {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  .empty {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(50%);
    font-size: 14px;
    color: #8f9197;
  }
  .top-title {
    position: absolute;
    top: 0;
    z-index: 1000;
    width: calc(100% - 262px);
    height: 26px;
    line-height: 26px;
    color: white;
    background-color: #003e8e;
    padding-left: 20px;
    box-sizing: border-box;
    font-size: 13px;
  }
  .power-curve-content {
    padding-top: 30px;
  }
  .res-chart {
    height: 400px;
    padding-bottom: 20px;
    width: 99%;
    margin: 15px auto 20px;
  }
  .e-container {
    width: 100%;
    height: 100%;
  }
  .power-curve {
    position: relative;
    top: 30px;
    left: 20px;
    width: 100%;
    //z-index: 1000;
    //background-color: #0477a1;
    min-height: 40px;
    padding-left: 20px;
    color: #fff;
    display: flex;
    box-sizing: border-box;
    .power-curve-item:nth-child(3) {
      box-sizing: border-box;
    }
    .power-curve-item {
      display: flex;
      align-items: center;
      color: #fff;
      padding-right: 40px;
      /deep/.el-select {
        min-width: 250px;
      }
    }
  }
  /deep/.el-input__inner {
    background-color: @bgColor;
    border: none;
    border-bottom: 1px solid #fff;
    border-radius: 0;
    outline: none;
    color: #fff;
    text-align: center;
    /*max-width: 160px;*/
  }
  /deep/.el-select .el-input .el-input__suffix {
    display: block;
  }
  /deep/.el-select__tags {
    max-width: 100% !important;
    /deep/.el-tag--info {
      background-color: transparent;
      border: none;
      color: #fff;
      text-align: center;
    }
  }
  .power-curve-compare {
    // max-height: 505px;
    // overflow-y: scroll;
    box-sizing: border-box;
    margin-top: 50px;
  }
  .top {
    display: flex;
    align-items: center;
    justify-content: space-around;
    position: relative;
    .confirm-btn {
      //position: absolute;
      bottom: 0;
      right: 10%;
      // z-index: 2000;
    }
  }

  .compare-top {
    /deep/.el-input__inner {
      background-color: @bgColor;
      border: none;
      border-bottom: 1px solid #fff;
      border-radius: 0;
      outline: none;
      color: #fff;
      text-align: center;
      /*max-width: 160px;*/
    }
    /deep/.el-select .el-input .el-input__suffix {
      display: block;
    }
    /deep/.el-select__tags {
      max-width: 100% !important;
      /deep/.el-tag--info {
        background-color: transparent;
        border: none;
        color: #fff;
        text-align: center;
      }
    }
    // display: flex;
    // flex-direction: column;
    position: relative;
    left: 20px;
    width: 100%;
    // justify-content: center;
    // position: absolute;
    // top: 20px;
    // z-index: 1000;
    padding-top: 40px;
    // width: calc(100% - 400px);
    overflow: hidden;
    .header-select {
      display: flex;
      align-items: center;
      height: 40px;
      line-height: 40px;
      //background-color: #0477a1;
      margin-top: 5px;
      padding-left: 20px;
      //border: 1px solid black;
      background-color: @bgColor;
      margin-top: 5px;
      padding-left: 20px;
      border: 1px solid @bgColor;
      color: #fff;
      div {
        margin-right: 20px;
      }
      div:first-child {
        min-width: 240px;
      }
    }
    .header-select:first-child {
      margin: 0;
    }
  }
}
/deep/.closeTag {
  display: none !important;
}
</style>
<style lang="less" scoped>
/deep/.el-table th.gutter {
  display: table-cell !important;
  border-bottom: 0;
}
/deep/.el-table thead.is-group th {
  background-color: #0477a1;
  color: #fff;
}
/deep/.el-table th {
  background-color: #0477a1;
  color: #fff;
  text-align: center;
}
/deep/.el-table td {
  text-align: center;
  color: #fff;
}
/deep/.el-table tr:nth-of-type(odd) {
  background-color: #1e608f;
  color: #fff;
}
/deep/ .el-table tr:nth-of-type(even) {
  background-color: #126e6d;
  color: #fff;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #0477a1;
}
/deep/.el-table__body tr.current-row > td {
  background-color: #0477a1;
}
</style>
